define('FacetsSorting.EntryPoint',
  [
    'Facets.FacetedNavigation.View',
    'underscore'
  ],
  function (
    FacetsFacetedNavigationView,
    _
  ) {
    'use strict';

    function getFacetPriority(translator, facet) {
      var config = translator.getFacetConfig(facet.id);
      return parseInt(config && config.priority, 10) || 0;
    }

    return {
      mountToApp: function mountToApp() {
        FacetsFacetedNavigationView.prototype.childViews['Facets.FacetedNavigationItems'] = _.wrap(
          FacetsFacetedNavigationView.prototype.childViews['Facets.FacetedNavigationItems'],
          function (fn) {
            var translator = this.options.translator;
            var collectionView = fn.apply(this, _.toArray(arguments).slice(1));

            var sortedModels = collectionView.collection.models.slice().sort(function (modelA, modelB) {
              return getFacetPriority(translator, modelB.attributes) - getFacetPriority(translator, modelA.attributes);
            });

            collectionView.collection.reset(sortedModels);

            return collectionView;
          }
        );
      }
    };
  });
